class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.navCategoriesFocus = this.querySelectorAll('summary a, summary, [class*="nav-l"');
    this.navCategoriesFocus.forEach(element => {
      element.addEventListener("focus", this.updateAccessibeTooltip);
      element.addEventListener("mouseover", this.updateAccessibeTooltip);
    });

    this.navCategoriesBlur = this.querySelectorAll('*')
    this.navCategoriesBlur.forEach(element => {
      element.addEventListener("blur", this.removeAccessibeTooltip);
      element.addEventListener("mouseout", this.removeAccessibeTooltip);
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  updateAccessibeTooltip = (event) => {
    const ascbTooltipElement = this.closest('.list-menu__list-item');
    ascbTooltipElement.removeAttribute('data-acsb-tooltip-bound');
    ascbTooltipElement.setAttribute('data-acsb-tooltip', event.target.textContent.trim());
  }

  removeAccessibeTooltip = (event) => {
    const ascbTooltipElement = this.closest('.list-menu__list-item');
    ascbTooltipElement.removeAttribute('data-acsb-tooltip-bound');
    ascbTooltipElement.removeAttribute('data-acsb-tooltip');
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
